import styles from "../../main/Filters/Filters.module.scss";
import SearchFilter from "../../../SearchFilter/SearchFilter";
import DateFilter from "./DateFilter/DateFilter";
import ExportImportFilters from "./ExportImportFilters/ExportImportFilters";
import StanFilter from "./StanFilter/StanFilter";
import { useActions } from "../../../../hooks/useActions";
import { CustomCheckbox } from "../../../../share/Input/Input";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import DatasetsDropdown from "../../_mapFilterComponents/DatasetsDropdown/DatasetsDropdown";
import RegionDropdown from "../../main/RegionDropdown/RegionDropdown";
import { useTranslation } from "react-i18next";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import AddMoreFiltersButton from "../../../templates/AddSavedFilters/AddMoreFiltersButton";
import ClearAllFiltersDesktopButton from "../../../../share/filters/ClearAllFiltersDesktopButton";
import MobileClearAllButton from "../../../../share/filters/MobileClearAllButton";
import SavedFiltersButton from "../../../templates/SavedFilters/SavedFiltersButton/SavedFiltersButton";
import { useEffect } from "react";
import styled from "@emotion/styled";
import {
  ListViewActions,
  ListViewContainer,
  ListViewFilterGroup,
  ListViewSearchRow,
  ListViewSearchSection,
  ListViewSearchWrapper,
  ListViewTopContainer,
  MapToggleButton,
} from "../../shared/ListViewLayout";
import { breakpoints, icons } from "../../../../constants";
import { UserProfileListControls } from "../../../UserProfileBar/UserProfileBar";

const ListViewCheckboxRow = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

interface FiltersProps {
  isListView?: boolean;
}

const Filters = ({ isListView = false }: FiltersProps) => {
  const {
    setCleanAllCompanyFilters,
    getDefaultCompanyResult,
    setKvedIsMain,
    setOffset,
    setPage,
    setIsListViewActive,
  } = useActions();

  const { kved_is_main } = useTypedSelector((state) => state.companyFilters);
  const currentAccountId = useTypedSelector(
    (state) => state.currentAccount?.id
  );
  const handleClick = () => {
    setOffset(0);
    setPage(1);
  };
  const handleBuildChange = () => {
    setKvedIsMain(!kved_is_main);
    handleClick();
  };
  const handleClean = () => {
    setCleanAllCompanyFilters();
    getDefaultCompanyResult();
  };

  useEffect(() => {
    handleClean();
  }, [currentAccountId]);

  const { t: tCompanies } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.companies",
  });

  const isMobile = useMobileScreen();
  const isBelowMedium = useMobileScreen(breakpoints.medium);
  const shouldRenderListView = isListView && !isBelowMedium;

  const handleShowMap = () => {
    setIsListViewActive(false);
  };

  if (shouldRenderListView) {
    return (
      <ListViewContainer>
        <ListViewTopContainer>
          <div className={styles.regionsDatasetsWrapper}>
            <RegionDropdown />
            <DatasetsDropdown />
          </div>
          <ListViewActions>
            <SavedFiltersButton />
            <AddMoreFiltersButton />
            <UserProfileListControls />
          </ListViewActions>
        </ListViewTopContainer>
        <ListViewSearchSection>
          <ListViewCheckboxRow>
            <CustomCheckbox
              children={tCompanies("mainKVEDsearch")}
              checked={kved_is_main}
              onChange={handleBuildChange}
              style={styles.checkboxLabel}
            ></CustomCheckbox>
          </ListViewCheckboxRow>
          <ListViewSearchRow>
            <MapToggleButton
              type="button"
              onClick={handleShowMap}
              aria-label="Show map view"
            >
              <img src={icons.NavMapIcon} alt="Show map view" />
            </MapToggleButton>
            <ListViewSearchWrapper>
              <SearchFilter />
            </ListViewSearchWrapper>
            <ListViewFilterGroup onClick={(event) => event.stopPropagation()}>
              <ExportImportFilters fullWidth={false} />
              <StanFilter />
              <DateFilter fullWidth={false} />
              {isMobile && <MobileClearAllButton onClick={handleClean} />}
            </ListViewFilterGroup>
          </ListViewSearchRow>
        </ListViewSearchSection>
        {!isMobile && <ClearAllFiltersDesktopButton onClick={handleClean} />}
      </ListViewContainer>
    );
  }

  return (
    <div
      className={`${styles.companyDatasetFilters} ${styles.filterMainWrapper}`}
    >
      <div className={styles.topContainer}>
        <div className={styles.regionsDatasetsWrapper}>
          <RegionDropdown />
          <DatasetsDropdown />
        </div>
        <div className={styles.topContainerButtons}>
          <SavedFiltersButton />
          <AddMoreFiltersButton />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <CustomCheckbox
          children={tCompanies("mainKVEDsearch")}
          checked={kved_is_main}
          onChange={handleBuildChange}
          style={styles.checkboxLabel}
        ></CustomCheckbox>
      </div>

      <div className={styles.searchWrapper}>
        <SearchFilter />
      </div>
      <div
        className={styles.filterGroup}
        onClick={(event) => event.stopPropagation()}
      >
        <ExportImportFilters />
        <StanFilter />
        <DateFilter />
        {isMobile && <MobileClearAllButton onClick={handleClean} />}
      </div>
      {!isMobile && <ClearAllFiltersDesktopButton onClick={handleClean} />}
    </div>
  );
};

export default Filters;
